import { Theme, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';
import { makeStyles } from 'tss-react/mui';

const InfoItem: FC<React.PropsWithChildren<InfoItemProps>> = ({
  name,
  data,
}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.item}>
      <div className={classes.name}>
        <Typography variant='body2' color='text.secondary'>
          {name}:
        </Typography>
      </div>
      <div className={classes.data}>{data}</div>
    </div>
  );
};
const useStyles = makeStyles()((theme: Theme) => ({
  item: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  },
  name: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    alignItems: 'center',
    width: '50%',
  },
  data: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    alignItems: 'center',
    width: '50%',
    overflowWrap: 'break-word',
  },
}));

export interface InfoItemProps {
  name: string;
  data: ReactNode;
}

export default InfoItem;
